import { useState, type CSSProperties, type ReactNode } from 'react'
import { SegmentedControl } from 'app/components/action-center/SegmentedControl'
import { cn } from 'app/lib/utils'

type Device = `desktop` | `phone`

const MODES = [
  { id: false, label: `Edit` },
  { id: true, label: `Preview` },
]

const DEVICES: { id: Device; label: string }[] = [
  { id: `desktop`, label: `Desktop` },
  { id: `phone`, label: `Phone` },
]

export function EditorModeToggle({ previewing, onChange }: { previewing: boolean; onChange: (on: boolean) => void }) {
  return <SegmentedControl options={MODES} value={previewing} onSelect={onChange} />
}

/** The patient page at the width they would open it. Phone is the frame most of them use. */
export function PreviewPane({ background, children }: { background: string; children: ReactNode }) {
  const [device, setDevice] = useState<Device>(`desktop`)
  return (
    <div className="flex flex-col gap-3 pb-10">
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm text-subtle">What the patient sees. Answers here are not saved.</span>
        <SegmentedControl options={DEVICES} value={device} onSelect={setDevice} />
      </div>
      {/* The scrollbar track is transparent, so the frame carries the page background too.
          Without it the dark app shows through the track and squares off the right corners. */}
      <div
        style={{ '--preview-bg': background } as CSSProperties}
        className={cn(
          `theme-light overflow-hidden border border-default bg-(--preview-bg) shadow-elevation-2`,
          device === `phone` ? `mx-auto h-160 w-full max-w-100 rounded-2xl` : `h-200 w-full rounded-xl`,
        )}
      >
        <div className="h-full overflow-y-auto">{children}</div>
      </div>
    </div>
  )
}
